'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default ['$scope', '$uibModalInstance', 'supportStage', 'SupportStageService', 'StatusService',
    function($scope, $modalInstance, supportStage = {}, SupportStageService, StatusService) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        /**
         * Инициализация
         */
        function init() {
            $scope.uniqueName = true;
            $scope.supportStage = angular.copy(supportStage);

            if (!(supportStage === null
                    || angular.equals({}, supportStage)
                    || supportStage.id === null)) {
                $scope.title = `Редактирование этапа сопровождения проекта "${$scope.supportStage.name}`;
            } else {
                $scope.title = 'Создание нового этапа сопровождения проекта';
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.supportStage.status) {
                    $scope.supportStage.status = data._embedded;
                }
            });
        }

        /**
         * Действие нажатия кнопки "Ok"
         */
        function ok() {
            $modalInstance.close($scope.supportStage);
        }

        /**
         * Действие нажатия кнопки "Cancel"
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Действие проверки уникальности имени
         * @param {string} name имя
         */
        function checkUniqueName(name) {
            if (name !== null && name.trim() !== '') {
                SupportStageService.api.isUniqueName({name: name}, {id: $scope.supportStage.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion
    }];
